import { TableCell, TableFooter, type TableFooterProps, TableRow } from "@mui/material";
import { type Ref, forwardRef } from "react";
import { useTableVirtualizedSelectContext } from "../context";

export const VirtuosoTableFoot = forwardRef(function VirtuosoTable(
  { children, ...props }: TableFooterProps,
  ref: Ref<HTMLTableSectionElement>
) {
  const { TableFootProps, hiddenCheckbox } = useTableVirtualizedSelectContext();

  return (
    <TableFooter {...props} {...TableFootProps} sx={{ position: "static !important" }} ref={ref}>
      <TableRow>
        {!hiddenCheckbox && <TableCell />}
        {children}
      </TableRow>
    </TableFooter>
  );
});
